
<div *ngIf="phoneApp">s
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" style="padding-top: 40%; color:white;font-size: 30px; padding-left: 0">Equipment Inquiry </div>
    </div>
    <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
      <tr>
        <td  >
          <table  class="table-fill" style="height: 100%; text-align: center">
            <tr>
              <td style="vertical-align: top;">
                <div>
                  <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">
                    <div class="lowerCaseLetters" style="font-size: 14px;text-align: left; padding-left: 5%;padding-bottom: 3px ">Container Number</div>
                    <mat-form-field class="newField" style=" font-size: 17px; min-width: 90%; max-width: 90%; padding: 10px" appearance="outline" >
                      <input  [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()">
                      <mat-icon (click)="getSearchItems()" matSuffix><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>

                    </mat-form-field>
                  </mat-card>
                </div>

                <div *ngIf="showDetailScreen">


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="container"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">General Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Container</mat-label>
                        <input [(ngModel)]="cv.container" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">ISO</mat-label>
                        <input [(ngModel)]="cv.iso_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Line Op Owner</mat-label>
                        <input [(ngModel)]="cv.ssl_owner_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Line Id</mat-label>
                        <input [(ngModel)]="cv.line_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Over Dimensions</mat-label>
                        <input [(ngModel)]="cv.is_oogFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Hazardous</mat-label>
                        <input [(ngModel)]="cv.hazardousFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Running Reefer</mat-label>
                        <input [(ngModel)]="cv.requires_powerFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Days On Terminal</mat-label>
                        <input [(ngModel)]="cv.dwell_days" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">FTE</mat-label>
                        <input [(ngModel)]="cv.fte_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Lease</mat-label>
                        <input [(ngModel)]="cv.lease_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Group</mat-label>
                        <input [(ngModel)]="cv.group_code" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%" *ngIf="cv.inbound_mode!=' '">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="inbound"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Inbound Activity</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Inbound Mode</mat-label>
                        <input [(ngModel)]="cv.inbound_mode" matInput readonly/>
                      </mat-form-field>


                      <div  *ngIf="cv.inbound_mode=='TRAIN'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Railroad</mat-label>
                          <input [(ngModel)]="cv.in_railroad" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <div  *ngIf="cv.inbound_mode=='VESSEL'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Vessel</mat-label>
                          <input [(ngModel)]="cv.in_vessel_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Voyage</mat-label>
                          <input [(ngModel)]="cv.in_voyage" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <div  *ngIf="cv.inbound_mode=='TRUCK'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Visit</mat-label>
                          <input [(ngModel)]="cv.in_visit" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Trucker</mat-label>
                          <input [(ngModel)]="cv.in_trucking_co_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Driver</mat-label>
                          <input [(ngModel)]="cv.in_driver_name" matInput readonly/>
                        </mat-form-field>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Received Date</mat-label>
                        <input [(ngModel)]="cv.received_date_fmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%" *ngIf="cv.outbound_mode!=' '">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="outbound"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Outbound Activity</div>
                      </div>


                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Outbound Mode</mat-label>
                        <input [(ngModel)]="cv.outbound_mode" matInput readonly/>
                      </mat-form-field>


                      <div  *ngIf="cv.inbound_mode=='TRAIN'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Railroad</mat-label>
                          <input [(ngModel)]="cv.out_railroad" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <div  *ngIf="cv.inbound_mode=='VESSEL'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Vessel</mat-label>
                          <input [(ngModel)]="cv.out_vessel_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Voyage</mat-label>
                          <input [(ngModel)]="cv.out_voyage" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <div  *ngIf="cv.inbound_mode=='TRUCK'">
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Visit</mat-label>
                          <input [(ngModel)]="cv.out_visit" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Trucker</mat-label>
                          <input [(ngModel)]="cv.out_trucking_co_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Driver</mat-label>
                          <input [(ngModel)]="cv.out_driver_name" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Delivered Date</mat-label>
                        <input [(ngModel)]="cv.delivered_date_fmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="weights"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Weight Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Gross Weight</mat-label>
                        <input [(ngModel)]="cv.gross_weightFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Tare Weight</mat-label>
                        <input [(ngModel)]="cv.tare_weightFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Cargo Weight</mat-label>
                        <input [(ngModel)]="cv.cargo_weightFmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="booking"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Booking & Routing Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Booking</mat-label>
                        <input [(ngModel)]="cv.booking" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Booking Line Op</mat-label>
                        <input [(ngModel)]="cv.booking_line_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Port of Loading</mat-label>
                        <input [(ngModel)]="cv.port_of_loading_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Port of Discharge</mat-label>
                        <input [(ngModel)]="cv.port_of_discharge_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Origin</mat-label>
                        <input [(ngModel)]="cv.port_of_origin_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Port of Destination</mat-label>
                        <input [(ngModel)]="cv.port_of_dest_description" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>


                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</div>


<table class="mainTable" style="width: 100%">
  <tr>
    <td class="mainUpperTd">

      <mat-card class="quickView" *ngIf="showQuickView">
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 18%" >
              <div class="maher" (click)="myApp.showCharts()"></div>
            </td>
            <td style="width: 70%">
              <div >
                <mat-form-field class="search"  appearance="outline">
                  <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
                  <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/cargo_container.png" ></mat-icon>
                  <input  maxlength="30" style="padding-left: 20px;"   matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                </mat-form-field>
              </div>
              <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 24%">Click On Any Row To View Details For The Container</div>
            </td>
            <td style="width: 20%" *ngIf="ipadApp">
              <div >
                <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
              </div>
            </td>
          </tr>
        </table>

        <div class="flex-item2" >
          <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
            <ng-container matColumnDef="container" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.container}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="fcy_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Facility</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.fcy_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="line_id" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
              <mat-cell style="flex: 0 0 8.2% !important;" *matCellDef="let row">{{row.line_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="iso_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">ISO</mat-header-cell>
              <mat-cell style="flex: 0 0 14.1% !important;"  *matCellDef="let row">{{row.iso_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="category_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Category</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.category_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="freight_kind_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Freight</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.freight_kind_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="transit_state_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Transit</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.transit_state_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="received_date_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Received</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.received_date_fmt}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="delivered_date_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Delivered</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.delivered_date_fmt}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" (click)="showDetails(row)"></mat-row>
          </mat-table>
          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; ">
              <mat-paginator class="myPaginator"   [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
              <span style="padding-left: 24%">
                  <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel()"><img style="height: 38px"  src="assets/excel.png" ></button>
                    </span>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
      </mat-card>


      <mat-card class="details" *ngIf="showDetailScreen"  id="printTable2">
        <table style="width: 100%; height: 90%">
          <tr>
            <td style="width: 93%;">


              <mat-card class="contDetails" >


                <table style="width: 100%">
                  <tr>
                    <div class="maher2" (click)="myApp.showCharts()"></div>
                    <td style="width: 13%">
                      <div class="titleFont" style="font-size: 21px">Facility:<a style="color: green"> {{cv.fcy_description}}</a></div>
                    </td>
                    <td style="width: 23%">
                      <div class="titleFont" style="font-size: 21px">Container:<a style="color: green"> {{cv.container}}</a></div>
                    </td>
                    <td style="width: 19%">
                      <div class="titleFont" style="font-size: 21px">Category:<a style="color: green"> {{cv.category_description}}</a></div>
                    </td>
                    <td style="width: 15%">
                      <div class="titleFont" style="font-size: 21px">Freight:<a style="color: green"> {{cv.freight_kind_description}}</a></div>
                    </td>
                    <td style="width: 20%">
                      <div class="titleFont" style="font-size: 21px;">Transit: <a style="color: green">{{cv.transit_state_description}}</a></div>
                    </td>
                    <td style="width: 11%">
                      <div class="lowerCaseLetters" [hidden]="inqView.length==1" (click)="returnToQuickView()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Quick View</div>
                    </td>
                  </tr>
                </table>







                <table style="width: 100%; padding: 0px; margin: 0px">
                  <tr>
                    <td style="min-width: 90%; height: 100%; text-align: center;" >

                      <table  class="table-fill" style="height: 100%">
                        <tr>
                          <div style="background-color: rgba(238,238,237,0.4); border: #E61E00 1px solid; height: 100%; max-width: max-content">
                            <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">General Information</div>


                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field appearance="outline"  >
                                  <mat-label style="font-size: 18px; color: #E61E00">Container</mat-label>
                                  <input [(ngModel)]="cv.container" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">ISO</mat-label>
                                  <input [(ngModel)]="cv.iso_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>

                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field appearance="outline"  >
                                  <mat-label style="font-size: 18px; color: #E61E00">Line Op Owner</mat-label>
                                  <input [(ngModel)]="cv.ssl_owner_description" matInput readonly />
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Lease</mat-label>
                                  <input [(ngModel)]="cv.lease_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>

                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field appearance="outline"  >
                                  <mat-label style="font-size: 18px; color: #E61E00">Line Id</mat-label>
                                  <input [(ngModel)]="cv.line_description" matInput readonly />
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Grade</mat-label>
                                  <input [(ngModel)]="cv.grade_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>

                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Over Dimensions</mat-label>
                                  <input [(ngModel)]="cv.is_oogFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Group</mat-label>
                                  <input [(ngModel)]="cv.group_code" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>

                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Hazardous</mat-label>
                                  <input [(ngModel)]="cv.hazardousFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Running Reefer</mat-label>
                                  <input [(ngModel)]="cv.requires_powerFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>


                            <div class="two-col">
                              <div class="col1">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Days On Terminal</mat-label>
                                  <input [(ngModel)]="cv.dwell_days" matInput readonly/>
                                </mat-form-field>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">FTE</mat-label>
                                  <input [(ngModel)]="cv.fte_date" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div class="col2">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Remarks</mat-label>
                                  <textarea style="max-height: 65px; min-height: 65px" [(ngModel)]="cv.remarks" matInput readonly></textarea>
                                </mat-form-field>
                              </div>
                            </div>

                            <div class="two-col">
                              <div class="col1">

                              </div>
                            </div>


                          </div>


                          <td style="vertical-align: top; height: 100%" *ngIf="cv.inbound_mode!=' ' || cv.category!=null">
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Inbound Activity</div>

                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Inbound Mode</mat-label>
                                  <input [(ngModel)]="cv.inbound_mode" matInput readonly/>
                                </mat-form-field>
                              </div>


                              <div  *ngIf="cv.inbound_mode=='TRAIN'">
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Railroad</mat-label>
                                    <input [(ngModel)]="cv.in_railroad" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>

                              <div  *ngIf="cv.inbound_mode=='VESSEL'">
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Vessel</mat-label>
                                    <input [(ngModel)]="cv.in_vessel_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Voyage</mat-label>
                                    <input [(ngModel)]="cv.in_voyage" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>

                              <div style="padding-top: 5px" *ngIf="cv.inbound_mode=='TRUCK'">
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Visit</mat-label>
                                    <input [(ngModel)]="cv.in_visit" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Trucker</mat-label>
                                    <input [(ngModel)]="cv.in_trucking_co_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div  >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Driver</mat-label>
                                    <input [(ngModel)]="cv.in_driver_name" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>



                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Received Date</mat-label>
                                  <input [(ngModel)]="cv.received_date_fmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Location</mat-label>
                                  <input [(ngModel)]="cv.location" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>



                          <td style="vertical-align: top; height: 100%" *ngIf="cv.outbound_mode!=' ' || cv.category!=null">
                            <div style="background-color: rgba(238,238,237,0.4); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Outbound Activity</div>

                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Outbound Mode</mat-label>
                                  <input [(ngModel)]="cv.outbound_mode" matInput readonly/>
                                </mat-form-field>
                              </div>


                              <div  *ngIf="cv.outbound_mode=='TRAIN'">
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Railroad</mat-label>
                                    <input [(ngModel)]="cv.out_railroad" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>

                              <div  *ngIf="cv.outbound_mode=='VESSEL'">
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Vessel</mat-label>
                                    <input [(ngModel)]="cv.out_vessel_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Voyage</mat-label>
                                    <input [(ngModel)]="cv.out_voyage" matInput readonly/>
                                  </mat-form-field>
                                </div>

                              </div>

                              <div style="padding-top: 5px" *ngIf="cv.outbound_mode=='TRUCK'">
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Visit</mat-label>
                                    <input [(ngModel)]="cv.out_visit" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div  >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Trucker</mat-label>
                                    <input [(ngModel)]="cv.out_trucking_co_description" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Driver</mat-label>
                                    <input [(ngModel)]="cv.out_driver_name" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>



                              <div *ngIf="cv.delivered_date!=null">
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Delivered Date</mat-label>
                                  <input [(ngModel)]="cv.delivered_date_fmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>


                          <td style="vertical-align: top; height: 100%" *ngIf="cv.category!=null">
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Weight Information</div>
                              <div style="padding-top: 2px">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Gross Weight</mat-label>
                                  <input [(ngModel)]="cv.gross_weightFmt"  matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Tare Weight</mat-label>
                                  <input [(ngModel)]="cv.tare_weightFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Cargo Weight</mat-label>
                                  <input [(ngModel)]="cv.cargo_weightFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div *ngIf="cv.seal_1!=' '" >

                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Seal Information</div>
                                <div>
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Seal 1</mat-label>
                                    <input [(ngModel)]="cv.seal_1" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Seal 2</mat-label>
                                    <input [(ngModel)]="cv.seal_2" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Seal 3</mat-label>
                                    <input [(ngModel)]="cv.seal_3" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Seal 4</mat-label>
                                    <input [(ngModel)]="cv.seal_4" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>



                            </div>
                          </td>





                          <td style="vertical-align: top; height: 100%" *ngIf="cv.category!=null">
                            <div style="background-color: rgba(238,238,237,0.4); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Booking & Routing Info</div>

                              <div style="padding-top: 2px">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Booking</mat-label>
                                  <input [(ngModel)]="cv.booking"  matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div style="padding-top: 2px">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Booking Line Op</mat-label>
                                  <input [(ngModel)]="cv.booking_line_description"  matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div style="padding-top: 2px">
                                <mat-form-field appearance="outline">
                                  <mat-label style="font-size: 18px; color: #E61E00">Port of Loading</mat-label>
                                  <input [(ngModel)]="cv.port_of_loading_description"  matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Port of Discharge</mat-label>
                                  <input [(ngModel)]="cv.port_of_discharge_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Origin</mat-label>
                                  <input [(ngModel)]="cv.port_of_origin_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Port of Destination</mat-label>
                                  <input [(ngModel)]="cv.port_of_dest_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>


                        </tr>
                      </table>


                    </td>
                  </tr>
                </table>
              </mat-card>

              <mat-card class="contDetails" >
                <table style="width: 100%">
                  <tr>
                    <td style="width: 84%">
                      <div class="titleFont2 titleFont " *ngIf="historyView.length>0"  >Container History: {{historyView.length}} Records</div>
                    </td>
                    <td style="width: 8%">
                      <div class="lowerCaseLetters" [hidden]="txtArray2.length==1" (click)="previousContainer()" style="font-size: 14px; color: #E61E00; cursor: pointer">Prev Container</div>
                    </td>
                    <td style="width: 8%">
                      <div class="lowerCaseLetters" [hidden]="txtArray2.length==1" (click)="nextContainer()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Container</div>
                    </td>
                  </tr>
                </table>

                <div *ngIf="historyView.length>0">
                  <table style="width: 100%; padding: 0px; margin: 0px" id="printTable">
                    <tr>
                      <td style="width: 85%; height: 100%; text-align: center;" >
                        <table  class="table-fill">
                          <tr>
                            <td style="vertical-align: top">
                              <div style="background-color: rgba(238,238,237,0.4); border: #E61E00 1px solid">

                                <div class="flex-item4" >
                                  <mat-table #table23 [dataSource]="quickViewData2" multiTemplateDataRows matSort="container" >
                                    <ng-container matColumnDef="container" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.container}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="fcy_description" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Facility</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.fcy_description}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="line_id" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.line_id}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="category_description" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Category</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.category_description}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="freight_kind_description" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Freight Kind</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.freight_kind_description}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="transit_state_description" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Transit</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.transit_state_description}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="received_date_fmt" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Received</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.received_date_fmt}}</mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="delivered_date_fmt" >
                                      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Delivered</mat-header-cell>
                                      <mat-cell *matCellDef="let row">{{row.delivered_date_fmt}}</mat-cell>
                                    </ng-container>
                                    <mat-header-row *matHeaderRowDef="qvColumns2; sticky: true"></mat-header-row>
                                    <mat-row   *matRowDef="let row; columns: qvColumns2;" class="table-row" (click)="showHistoryDetails(row)"></mat-row>
                                  </mat-table>
                                </div>



                              </div>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>

              </mat-card>



              <mat-card class="contDetails">

                <mat-toolbar mat-toolbar class="toolbar4">
                  <mat-toolbar-row>
                    <div style="width: 100%;text-align: center">
                      <button mat-raised-button  class="whiteButton" [disabled]="cv.requires_power==null || cv.requires_power=='0'" (click)="openReefer()" ><img style="vertical-align: center;height:25px; width: 50px" src="assets/reefer.png" >  Reefer</button>
                      <span style="padding-left: 1%"></span>

                      <button mat-raised-button  class="whiteButton" [disabled]="cv.is_oog==null || cv.is_oog=='0'" (click)="openOds()"><img style="vertical-align: center;height:25px; width: 40px" src="assets/local_shipping-24px.svg" >  Over Dimensions</button>
                      <span style="padding-left: 1%"></span>

                      <button mat-raised-button  class="whiteButton" *ngIf="myUser.role=='LINEOP'" [disabled]="cv.hazardsArray.length==0 " (click)="openHazards()"><img style="vertical-align: center;height:35px; width: 35px" src="assets/hazards.png" >  Hazards</button>
                      <span style="padding-left: 1%" *ngIf="myUser.role=='LINEOP'"></span>

                      <button mat-raised-button  class="whiteButton" [disabled]="hArray.length==0" (click)="openHolds()"><img style="vertical-align: center;height:25px; width: 25px" src="assets/customs.png" > Holds</button>

                    </div>


                  </mat-toolbar-row>
                </mat-toolbar>

                <div>
                  <mat-accordion style="z-index: 200" >
                    <mat-expansion-panel [(expanded)]="showAcc" style="background-color: rgba(238,238,237,0.4);" hideToggle="true">


                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showReeferInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Reefer Information</div>
                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Container</mat-label>
                                      <input [(ngModel)]="cv.container" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Genset</mat-label>
                                      <input [(ngModel)]="cv.genset_requirement" matInput readonly />
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Temp Required</mat-label>
                                      <input [(ngModel)]="cv.temp_reqdFmt" matInput readonly />
                                    </mat-form-field>
                                  </div>

                                </td>
                                <td style="vertical-align: top">
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Vent Required</mat-label>
                                      <input [(ngModel)]="cv.vent_required_pct" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Vent Unit</mat-label>
                                      <input [(ngModel)]="cv.vent_unit_description" matInput readonly />
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Humidity</mat-label>
                                      <input [(ngModel)]="cv.humidity_required_pct" matInput readonly />
                                    </mat-form-field>
                                  </div>

                                </td>

                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>

                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showHoldsInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Container Holds</div>
                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">

                                  <div class="flex-item5" >
                                    <mat-table  [dataSource]="holdsData" multiTemplateDataRows matSort>
                                      <ng-container matColumnDef="type" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Type</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.type}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="code" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">ID</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.code}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="description" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Description</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.description}}</mat-cell>
                                      </ng-container>
                                      <mat-header-row *matHeaderRowDef="holdsColumns; sticky: true"></mat-header-row>
                                      <mat-row   *matRowDef="let row; columns: holdsColumns;" class="table-row"></mat-row>
                                    </mat-table>
                                  </div>
                                </td>


                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>

                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showHazInfo">
                        <div style="vertical-align: text-top">

                          <table style="width: 100%">
                            <tr>
                              <td style="width: 80%">
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Hazardous Information</div>
                              </td>
                              <td style="width: 10%" >
                                <div class="lowerCaseLetters" [hidden]="cv.hazardsArray.length==1 || myUser.role=='LINEOP'"  (click)="previousHazard()"  style="font-size: 14px; color: #E61E00; cursor: pointer">Previous Hazard</div>
                              </td>
                              <td style="width: 10%" >
                                <div class="lowerCaseLetters" [hidden]="cv.hazardsArray.length==1 || myUser.role=='LINEOP'" (click)="nextHazard()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Hazard</div>
                              </td>
                            </tr>
                          </table>


                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center; " >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">

                                  <div class="flex-item5" style="background-color: rgba(238,238,237,0.4);">

                                    <table style="width: 100%">
                                      <tr>
                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">IMDG Class</mat-label>
                                              <input [(ngModel)]="haz.imdgConcat" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">UNDG</mat-label>
                                              <input [(ngModel)]="haz.undgTypeConcat" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Quantity</mat-label>
                                              <input [(ngModel)]="haz.quantity" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>

                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Technical Name</mat-label>
                                              <input [(ngModel)]="haz.tech_name" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Proper Name</mat-label>
                                              <input [(ngModel)]="haz.proper_name" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Notes</mat-label>
                                              <input [(ngModel)]="haz.notes" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>


                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Package Type</mat-label>
                                              <input [(ngModel)]="haz.package_type" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Package Group</mat-label>
                                              <input [(ngModel)]="haz.package_group" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Weight</mat-label>
                                              <input [(ngModel)]="haz.weightDisp" matInput readonly/>
                                            </mat-form-field>
                                          </div>

                                        </td>
                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">FlashPoint</mat-label>
                                              <input [(ngModel)]="haz.flashpoint_fmt" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Emergency Phone</mat-label>
                                              <input [(ngModel)]="haz.emergency_telephone_fmt" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Marine Pollutants</mat-label>
                                              <input [(ngModel)]="haz.marine_pollutants" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                      </tr>

                                    </table>

                                  </div>
                                </td>


                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>

                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showODInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Over Dimensions</div>
                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >



                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Over Height</mat-label>
                                      <input [(ngModel)]="cv.over_heightFmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Over Length Front</mat-label>
                                      <input [(ngModel)]="cv.over_length_frontFmt" matInput readonly />
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Over Length Rear</mat-label>
                                      <input [(ngModel)]="cv.over_length_rearFmt" matInput readonly />
                                    </mat-form-field>
                                  </div>

                                </td>
                                <td style="vertical-align: top">
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Over Width Left</mat-label>
                                      <input [(ngModel)]="cv.over_width_leftFmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Over Width Right</mat-label>
                                      <input [(ngModel)]="cv.over_width_rightFmt" matInput readonly />
                                    </mat-form-field>
                                  </div>

                                </td>

                              </tr>
                            </table>


                          </td>
                        </tr>
                      </table>



                    </mat-expansion-panel>
                  </mat-accordion>
                </div>

              </mat-card>

            </td>
            <td class="loginPic" style="">

            </td>
          </tr>
        </table>
      </mat-card>


    </td>
    <td class="mainLowerTd" id="noPrint">
              <mat-card class="speech-bubble" *ngIf="ipadAppear">
                <div class="account" style="margin-top: 2%;"></div>
                <div class="titleFont" style="padding-bottom: 10px; text-align: center; padding-left: 0%">Container Inquiry</div>
                <div  class="lowerCaseLetters" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Containers</div>
                <div class="flex-item3" style="text-align: center">
                  <mat-form-field  appearance="outline" class="newField" >
                    <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
                  </mat-form-field>
                </div>
                <div class="errorDiv2" style="text-align: center" *ngIf=" didntEnterShit">Must Have 1 Container</div>
                <div class="errorDiv2" style="text-align: center" *ngIf="badContainer">No Container Found or Unauthorized to view</div>
                <div class="errorDiv2" style="text-align: center" *ngIf="insertNoConts">Must Have At Least 1 Container For Insert</div>
                <div class="errorDiv2" style="text-align: center" *ngIf="badChars">Invalid Character in {{containerNum}}</div>


                <mat-toolbar mat-toolbar class="toolbar2">
                  <mat-toolbar-row style="justify-content: center">
                    <button mat-raised-button (click)="getSearchItems()"   class="blueButton" >Search</button>
                    <span class="example-fill-remaining-space3"></span>

                    <button mat-raised-button   class="redButton" (click)="wipeOutSearch()" >Clear List</button>

                  </mat-toolbar-row>
                </mat-toolbar>
                <div>
                  <mat-form-field class="myOption2"  appearance="outline">
                    <mat-label>Saved Lists</mat-label>
                    <mat-select  [(value)]="savedList" >
                      <mat-option  *ngFor="let lr of savedLists" [value]="lr.id">{{lr.description}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <mat-toolbar class="myToolbar" >
                  <mat-toolbar-row style="padding-left: 14%; height: 35px" >
                    <button mat-button matTooltip="retrieve your saved list" (click)="showContainersFromList()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
                    <button mat-button matTooltip="update your saved list" (click)="updateContainerList('U')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
                    <button mat-button matTooltip="delete your saved list" (click)="deleteHit()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/delete-24px.svg" ></button>
                  </mat-toolbar-row>
                </mat-toolbar>
                <mat-toolbar class="myToolbar" style="background-color: white">
                  <mat-toolbar-row >
                    <mat-form-field  class="myOption" appearance="outline" style="min-width: 76%; max-width: 76%">
                      <mat-label>New List</mat-label>
                      <input maxlength="15" [(ngModel)]="myNewListName"  oninput="this.value = this.value.toUpperCase()" matInput/>
                    </mat-form-field>
                    <button mat-button matTooltip="create a new saved list" (click)="updateContainerList('I')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>

                  </mat-toolbar-row>
                  <mat-toolbar-row style="height: 26px; justify-content: center">
                    <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && insertListExists">List Exists For This User</div>
                    <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && insertNoConts ">List Needs At Least 1 Container</div>
                    <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && noListName ">List Name Cannot Be Blank</div>
                  </mat-toolbar-row>
                </mat-toolbar>

              </mat-card>
    </td>
  </tr>
</table>




